// Kurumsal fatura alanları (snippets/shevec-kurumsal-fatura.liquid) için davranış.
// layout/theme.liquid her sayfada bir kez yükler: sepet çekmecesi bir <template> içinden kurulduğu için
// bölümün içine konan <script> orada çalışmıyordu.
(function () {
  if (window.__shevecKF) return;
  window.__shevecKF = true;
  var NO = /^\d{10,11}$/;
  function kutu(el) { return el && el.closest ? el.closest('[data-shevec-kf]') : null; }
  function alanlar(k) { return k.querySelectorAll('[data-kf-alan]'); }
  function eksik(i) { return i.hasAttribute('data-kf-no') ? !NO.test(i.value.trim()) : i.value.trim().length < 2; }
  function gecerli(k) {
    if (!k.querySelector('[data-kf-ac]').checked) return true;
    return !Array.prototype.some.call(alanlar(k), eksik);
  }
  var zaman;
  function kaydet(k) {
    clearTimeout(zaman);
    zaman = setTimeout(function () {
      var acik = k.querySelector('[data-kf-ac]').checked;
      var ozellik = { 'Fatura Türü': acik ? 'Kurumsal' : 'Bireysel' };
      alanlar(k).forEach(function (i) {
        var ad = i.name.replace(/^attributes\[|\]$/g, '');
        ozellik[ad] = acik ? i.value.trim() : '';
      });
      var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(kok + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: ozellik })
      }).catch(function () {});
    }, 400);
  }
  function ac(k, acik) {
    k.querySelector('[data-kf-tur]').value = acik ? 'Kurumsal' : 'Bireysel';
    k.querySelector('[data-kf-alanlar]').hidden = !acik;
    alanlar(k).forEach(function (i) { i.disabled = !acik; i.classList.remove('shevec-kf__alan--hata'); });
    if (!acik) k.querySelector('[data-kf-hata]').hidden = true;
  }
  document.addEventListener('change', function (e) {
    var k = kutu(e.target);
    if (!k) return;
    if (e.target.matches('[data-kf-ac]')) ac(k, e.target.checked);
    kaydet(k);
  });
  document.addEventListener('input', function (e) {
    var k = kutu(e.target);
    if (!k || !e.target.matches('[data-kf-alan]')) return;
    if (e.target.hasAttribute('data-kf-no')) e.target.value = e.target.value.replace(/\D/g, '').slice(0, 11);
    e.target.classList.remove('shevec-kf__alan--hata');
    kaydet(k);
  });
  function engelle(e) {
    var form = e.target.closest ? e.target.closest('form') : null;
    var k = form ? form.querySelector('[data-shevec-kf]') : null;
    if (!k || gecerli(k)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    k.querySelector('[data-kf-hata]').hidden = false;
    alanlar(k).forEach(function (i) { i.classList.toggle('shevec-kf__alan--hata', eksik(i)); });
    var ilk = k.querySelector('.shevec-kf__alan--hata');
    if (ilk) ilk.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[name="checkout"]')) engelle(e);
  }, true);
  document.addEventListener('submit', engelle, true);
})();
